import Icon from "@ant-design/icons";
import React from "react";

export const UpSvg = () => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16541 4.0459L4.06071 0.999982L1.0148 4.10468"
      stroke="#56B4A4"
    />
  </svg>
);

export const DownSvg = () => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.03259 1.12036L4.10804 4.19581L7.18348 1.12036"
      stroke="#56B4A4"
    />
  </svg>
);

export const SortSvg = () => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 13L0 8H10L5 13Z" fill="#6D8991" />
    <path d="M5 0.809082L10 5.80908L0 5.80908L5 0.809082Z" fill="#6D8991" />
  </svg>
);

export const WriteSvg = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clip-rule="evenodd"
      d="M13.6784 0.7391L12.9798 0.0405273L12.2728 0.730566L1.30154 11.4386L1.04561 11.6884L1.00612 12.0438L0.506123 16.5438C0.472576 16.8457 0.578092 17.1465 0.7929 17.3613C1.00771 17.5761 1.30851 17.6816 1.61044 17.6481L6.11044 17.1481L6.4659 17.1086L6.7157 16.8526L17.4229 5.88061L18.1129 5.1736L17.4144 4.47508L13.6784 0.7391ZM2.63193 15.5223L2.9544 12.6201L10.4412 5.31288L12.8408 7.71245L5.53411 15.1998L2.63193 15.5223ZM14.2377 6.28096L15.3016 5.19077L12.9627 2.85189L11.8726 3.91584L14.2377 6.28096Z"
      fill="#6D8991"
    />
  </svg>
);

export const DeleteSvg = () => (
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0.154297H4V2.1543H12V0.154297ZM16 6.1543H14V14.1783C14 16.284 12.4059 18.1543 10.2733 18.1543H5.72673C3.59415 18.1543 2 16.284 2 14.1783V6.1543H0V4.1543H16V6.1543ZM4 6.1543H12V14.1783C12 15.3475 11.1404 16.1543 10.2733 16.1543H5.72673C4.85961 16.1543 4 15.3475 4 14.1783V6.1543Z"
      fill="#6D8991"
    />
  </svg>
);

export const FullCardSvg = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 7.84766V1.84766C20 1.29537 19.5523 0.847656 19 0.847656H13V2.84766H16.5858L7.29289 12.1405L8.70711 13.5548L18 4.26187V7.84766H20ZM0 3.84766C0 2.74309 0.895431 1.84766 2 1.84766H9.5V3.84766H2V18.8477H17V11.3477H19V18.8477C19 19.9522 18.1046 20.8477 17 20.8477H2C0.89543 20.8477 0 19.9522 0 18.8477V3.84766Z"
      fill="#6D8991"
    />
  </svg>
);

export const ArrowSvg = () => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 5L0 0H10L5 5Z" fill="#6D8991" />
  </svg>
);

export const UpIco = (props) => <Icon component={UpSvg} {...props} />;
export const DownIco = (props) => <Icon component={DownSvg} {...props} />;
export const SortIco = (props) => <Icon component={SortSvg} {...props} />;
export const WriteIco = (props) => <Icon component={WriteSvg} {...props} />;
export const DeleteIco = (props) => <Icon component={DeleteSvg} {...props} />;
export const FullCardIco = (props) => (
  <Icon component={FullCardSvg} {...props} />
);
export const ArrowIco = (props) => <Icon component={ArrowSvg} {...props} />;
